export default [
  { name: '首頁', imgSrc: '', subTitle: '', section: 'section1', svgSrc: '' },
  { name: '山河海匯', imgSrc: '', subTitle: '', section: 'section2', svgSrc: '' },
  { name: '灣區最耀眼', imgSrc: '', subTitle: '', section: 'section3', svgSrc: '' },
  { name: '外觀日景', imgSrc: '', subTitle: '', section: 'section4', svgSrc: '' },
  { name: '頂級公設', imgSrc: '', subTitle: '', section: 'section5', svgSrc: '' },
  { name: '企業精神', imgSrc: '', subTitle: '', section: 'section6', svgSrc: '' },
  { name: '事業版圖', imgSrc: '', subTitle: '', section: 'section7', svgSrc: '' },
  { name: '預約賞屋', imgSrc: '', subTitle: '', section: 'contact', svgSrc: '' },
]